module.exports = __webpack_public_path__ + "img/avatar-7.9524b09f.jpg";